<template>
  <match-list></match-list>
</template>

<script>
import MatchList from '@/components/sports/main/popular/List'

export default {
  components: {
    MatchList
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sports/main/popular/View.vue